import React from 'react';
import './App.css';

import { HintContainerProvider } from '../src/components/GameScreen/context/useHintContainerContext';
import { OvertimeProvider } from '../src/components/GameScreen/context/useOvertimeContext';
import { HintProvider } from '../src/components/GameScreen/context/useHintContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { GameScreen } from './components/'

function App() {
  return (
      <OvertimeProvider>
        <HintContainerProvider>
          <HintProvider>
            <div className="App">
              <GameScreen />
              <ToastContainer />
            </div>
          </HintProvider>
        </HintContainerProvider>
      </OvertimeProvider>
  );
}

export default App;
